import {
  FixedSizeEnumConverter,
  EnumListConverter,
} from '@iotize/tap/client/impl';

export function createEnumConverter<T>(
  mapping: any,
  size: number,
): FixedSizeEnumConverter<T> {
  return new FixedSizeEnumConverter<T>(mapping, size);
}

export function createEnumArrayConverter<T>(
  mapping: any,
  size: number,
): EnumListConverter<T> {
  return new EnumListConverter<T>(size, mapping);
}
